import { Reveal, SectionLabel } from "./Reveal";

const Philosophy = () => (
  <section id="about" className="relative bg-white py-28 lg:py-40 overflow-hidden" data-testid="about-section">
    <div className="max-w-[1440px] mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-16 items-center">
      <div className="lg:col-span-7">
        <Reveal><SectionLabel>Philosophy — 08</SectionLabel></Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 font-display font-semibold text-3xl lg:text-5xl tracking-tight text-ink leading-[1.1]" data-testid="about-headline">
            WE DON'T JUST DESIGN KITCHENS.<br />
            <span className="text-skope">WE DESIGN THE SYSTEM BEHIND THE FOOD BUSINESS.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="mt-10 space-y-5 text-ink/55 leading-relaxed max-w-xl text-base lg:text-lg">
            <p>We believe a kitchen is not simply a space where food is prepared. It is a business system.</p>
            <p>
              Every menu decision affects production. Every production decision affects manpower.
              Every manpower decision affects cost. And every operational decision affects the
              ability of a food business to scale.
            </p>
            <p className="text-ink/80">That is why we look at kitchens commercially — not just spatially.</p>
          </div>
        </Reveal>
      </div>
      <div className="lg:col-span-5">
        <Reveal delay={0.25}>
          <div className="relative border border-ink/10">
            <img
              src="/assets/img/chef-plating.jpg"
              alt="Chef plating a dish with precision in a professional kitchen"
              className="w-full h-[420px] object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-white/60 to-transparent" />
            <div className="absolute -right-px -top-px w-6 h-6 border-r-2 border-t-2 border-skope" />
            <div className="absolute bottom-5 left-5 font-mono text-[10px] tracking-[0.25em] text-ink/70 uppercase">
              Fig. 02 — Precision is a business decision
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default Philosophy;
